import {computed, Injectable, signal} from '@angular/core';
import {delay, ReplaySubject, tap} from 'rxjs';
import {Profile} from '../models/profile.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileStateService {
  private _profileSubject = new ReplaySubject<Profile | null>(1);
  private _profileSignal = signal<Profile | null>(null)

  public profile$ = this._profileSubject.pipe(
    tap(profile => this._profileSignal.set(profile)),
    delay(0)
  );

  public profile = this._profileSignal.asReadonly();
  public isLoggedIn = computed(() => this._profileSignal() !== null);

  public updateProfile(profile: Profile | null) {
    this._profileSubject.next(profile);
  }
}
